export default __webpack_public_path__ + "static/media/senior_citizen_card.893a9436.jpg";